import ActionsForm from '@/shared/mixins/actionsForm'
import { toast } from '@/shared/utils/UIHelper'
import PersonForm from './infoPersonModal-form.js'

import AssociateRepository from '@/shared/http/repositories/business/associate.js'
import OriginRepository from '@/shared/http/repositories/configurations/origin.js'
import PersonRepository from '@/shared/http/repositories/configurations/person.js'

export default {
  name: 'InfoPersonModal',
  mixins: [ActionsForm],
  props: {
    card: {
      type: Object,
      default: () => ({})
    },
    cardActive: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      data: {},
      form: PersonForm,
      associate: null
    }
  },
  computed: {
    personType: function () {
      if (this.card.pessoa.tipoPessoa) {
        return this.card.pessoa.tipoPessoa
      }

      const doc = this.card.pessoa.document.replace(/\.|-|\//g, '')
      return doc && doc.length > 11 ? 'PJ' : 'PF'
    },
    formattedDataNascimento: function () {
      return this.card.pessoa.dataNascimento ? this.card.pessoa.dataNascimento.split('T')[0].split('-').reverse().join('/') : ''
    }
  },
  created () {
    this.getAllOrigin()
  },
  mounted () {
    this.syncData()
    this.showModal()
  },
  methods: {
    showModal () {
      this.$refs['modal-person'].show()
    },
    hideModal () {
      this.$emit('Reload')
    },
    syncData () {
      Object.assign(this.form, {
        name: { value: this.card.pessoa.nome },
        document: { value: this.card.pessoa.document },
        dataNascimento: { value: this.formattedDataNascimento },
        tipoPessoa: { value: this.card.pessoa.tipoPessoa || this.personType },
        leadOriginID: { value: this.card.origemLead ? this.card.origemLead.id : null }
      })
      if (!this.form) this.loadAssociate(this.card.pessoa.document)
    },
    loadAssociate (document) {
      if (!document) return

      AssociateRepository.Search(`document=${document}`, 1, 0)
        .then(({ data }) => {
          this.associate = data.content[0]
          this.form.numSisbr.value = this.associate.numSisbr || null
        })
        .catch(this.onException)
    },
    getAllOrigin () {
      OriginRepository.GetAll()
        .then(response => {
          this.form.leadOriginID.options = this.onResultDropdown(response, null, f => f.nome)
        })
        .catch(this.onException)
    },
    update () {
      if (!this.card.pessoa) return

      this.setPersonInData()
      PersonRepository.Patch(this.data)
        .then(response => {
          if (response.status === 200) {
            toast.success(this.$lang.Common.Alerts.Success)
            // createNewFollowupWithCard(this.card.pessoa.document, 'sys_atualizacao_cadastral', `O cadastro de ${pessoa.nomeAssociado} foi atualizado! `, this.ip, this.latitude, this.longitude, this.card.id)
            this.hideModal()
          }
        })
        .catch(this.onException)
    },
    setPersonInData () {
      this.data = {
        id: this.card.pessoa.id,
        nome: this.form.name.value,
        dataNascimento: this.form.dataNascimento ? this.form.dataNascimento.value.split('/').reverse().join('-') : ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/person/modal/infoPersonModal.js